import { IconProps, Icon } from "@chakra-ui/icon";

const ReworkIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5106 2.96698C13.8662 3.06228 14.0773 3.42784 13.982 3.78348C13.8867 4.13913 13.5211 4.35018 13.1655 4.25489L12.8951 4.18244C14.0278 7.05259 12.9194 10.3959 10.1669 11.9851C8.34323 13.038 6.21332 13.0802 4.42749 12.2879C4.09093 12.1386 3.93914 11.7447 4.08845 11.4082C4.23776 11.0716 4.63164 10.9198 4.96819 11.0692C6.38122 11.696 8.06125 11.6612 9.50023 10.8304C11.6042 9.61565 12.4914 7.10269 11.734 4.88754L11.6726 5.11681C11.5773 5.47246 11.2117 5.68351 10.8561 5.58822C10.5004 5.49292 10.2894 5.12737 10.3847 4.77172L10.8727 2.95036C10.968 2.59471 11.3336 2.38366 11.6892 2.47895L13.5106 2.96698Z"
        fill="black"
      />
      <path
        d="M9.57295 0.712599C9.9095 0.86191 10.0613 1.25578 9.91198 1.59234C9.76267 1.92889 9.3688 2.08069 9.03224 1.93138C7.61922 1.3045 5.93919 1.33935 4.50021 2.17014C2.39622 3.38488 1.50908 5.89786 2.26644 8.11303L2.32789 7.8837C2.42318 7.52806 2.78874 7.31701 3.14439 7.4123C3.50003 7.50759 3.71108 7.87315 3.61579 8.2288L3.12776 10.0502C3.03246 10.4058 2.6669 10.6169 2.31126 10.5216L0.489891 10.0335C0.134248 9.93824 -0.0768075 9.57268 0.018487 9.21704C0.113782 8.86139 0.479339 8.65034 0.834985 8.74563L1.10531 8.81807C-0.0273242 5.94792 1.08102 2.60461 3.83354 1.01544C5.65721 -0.0374509 7.78712 -0.0796738 9.57295 0.712599Z"
        fill="black"
      />
    </Icon>
  );
};

export default ReworkIcon;
